<div class="create-org-modal__backdrop animated fadeIn">
	<div class="create-org-modal__wrapper">
		<div class="create-org-modal">
			<div class="create-org-modal__header">
				<h3 class="create-org-modal__title">{{ data?.title }}</h3>
			</div>
			<div class="create-org-modal__content">
				<form class="create-org-modal__form create-org-form" [formGroup]="form">
					<div class="create-org-form__row">
						<mat-form-field appearance="outline">
							<mat-label>Company:</mat-label>
							<input matInput type="text" formControlName="company" autocomplete="off" />
						</mat-form-field>
					</div>
					<p class="create-org-form__row-title">Plan Name:</p>
					<div class="create-org-form__row">
						<mat-radio-group [color]="'primary'" formControlName="charge_model">
							<mat-radio-button [value]="'SuccessFee'">Success Fee</mat-radio-button>
							<mat-radio-button [value]="'FixPrice'">Fix Price</mat-radio-button>
						</mat-radio-group>
					</div>

					<div class="create-org-form__row" *ngIf="form.value.charge_model === 'SuccessFee'">
						<mat-form-field appearance="outline">
							<mat-label>Variable fee:</mat-label>
							<input matInput type="text" formControlName="varible_fee" autocomplete="off" />
						</mat-form-field>

						<mat-form-field appearance="outline">
							<mat-label>Plan description:</mat-label>
							<input matInput type="text" [readonly]="true" formControlName="plan_desc" autocomplete="off" />
						</mat-form-field>
					</div>

					<div class="create-org-form__row">
						<mat-checkbox formControlName="create_in_icount" [color]="'primary'"
							>Create organization profile in Netsuite system</mat-checkbox
						>
					</div>
				</form>
			</div>

			<div class="create-org-modal__actions">
				<button class="create-org-modal__close" (click)="closeEvent()">Close</button>
				<button class="create-org-modal__create" [disabled]="!form.valid" (click)="onSubmit()">Create</button>
			</div>
			<ng-container *ngIf="initProcess">
				<app-show-process [process]="processStatus | async"></app-show-process>
			</ng-container>
		</div>
	</div>
</div>
